import React from "react";
import TextField from "@liveramp/motif/core/TextField";

export default function OutlinedDemo() {
  return <TextField id="outlined-simple" />;
}
